import React from "react";
import { string, bool, node, shape, oneOf } from "prop-types";
import Inline from "../Inline";
import ForwardRefPropType from "../utils/forward-ref";
import { classes } from "../utils/classes";
import { useDropDown } from "../utils/DropDownProvider/context";

const DropdownItem = ({
	className = "",
	isOpen,
	isMegaMenu,
	forwardRef,
	children,
	dropdown,
	...props
}) => {
	const { currentAction } = useDropDown();
	return (
		<Inline
			forwardRef={forwardRef}
			className={classes(
				"dropdown",
				isMegaMenu && "dropdown--mega-menu",
				currentAction && `dropdown-action--${currentAction}`,
				isOpen && "dropdown--open",
				className,
			)}
			{...props}
		>
			{children}
		</Inline>
	);
};

DropdownItem.propTypes = {
	className: string,
	isOpen: bool,
	isMegaMenu: bool,
	dropdown: shape({
		action: oneOf(["onClick", "onHover", "onCSS"]),
		sm: shape({
			action: oneOf(["onClick", "onHover", "onCSS"]),
		}),
		md: shape({
			action: oneOf(["onClick", "onHover", "onCSS"]),
		}),
		lg: shape({
			action: oneOf(["onClick", "onHover", "onCSS"]),
		}),
	}),
	forwardRef: ForwardRefPropType,
	children: node,
};

export default DropdownItem;
